import React, { useContext } from "react";
import { Drawer, Layout } from "antd";
import SidebarContent from "./SidebarContent";

import { context } from '../../context';
import ViewportContext from '../../context/Viewport/viewportContext'

import SidebartContext from '../../context/sidebar/sidebarContext'

const { Sider } = Layout;

const Sidebar = () => {

  const { state, actions } = useContext(context);
  const { navStyle, themeType } = state
  // const { navStyle, navCollapsed, themeType } = state

  //instance of the viewport context
  const viewportContext = useContext(ViewportContext);
  const { width } = viewportContext


  //instance of the viewport context
  const sidebartContext = useContext(SidebartContext);
  const { navCollapsed, toggleCollapsedSideNav } = sidebartContext


  return (
    <Sider
      className={`gx-app-sidebar gx-collapsed-sidebar gx-layout-sider-dark`}
      trigger={null}
      collapsible
    >
      <Drawer
        className={`gx-drawer-sidebar gx-drawer-sidebar-dark`}
        placement="left"
        closable={false}
        onClose={toggleCollapsedSideNav}
        visible={navCollapsed}>
        <SidebarContent />
      </Drawer>
    </Sider>)
};
export default Sidebar;
